import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../types";
import { getApi } from "../apiPath";
import { axiosClient } from "../clients";

import type { IFaculties } from "./routeType";

const { key, getPath } = getApi("faculties.get");

type IExtractedRouteType = IFaculties["facultySingleRetrieve"];

export type IGetFaculty = IPickSingleQuery<IExtractedRouteType>;

const getFaculty: Fetcher<
  IGetFaculty["response"],
  IGetFaculty["variables"]
> = ({ facultyId, ...params }) => {
  return axiosClient.get(getPath({ facultyId }), { params });
};

export const useGetFaculty = createQuery({
  queryKey: [key],
  fetcher: getFaculty,
});
